import { api } from "../../../../helper/api";
import { mConstants } from "../../../../helper/constants";
import { IoPagination, PaginationInquiry } from "../../../../helper/pagination";
import { entityService } from "../../shared/service/entity.service";
import {
  CustomerRequest,
  CustomerRequestFilter,
} from "../entity/customer-request.model";

function getCustomerRequests(
  inquiry: CustomerRequestFilter
): Promise<IoPagination<CustomerRequest>> {
  return api.get(
    mConstants.API_URL + mConstants.ORDER_URL + "/customer/requests",
    { params: inquiry }
  );
}

function updateCustomerRequest(custoemrRequest: CustomerRequest) {
  return api.put(
    mConstants.API_URL + mConstants.ORDER_URL + "/customer/requests",
    custoemrRequest
  );
}

async function getCustomerRequest(requestId: string): Promise<CustomerRequest> {
  let customerRequest: CustomerRequest = await api.get(
    mConstants.API_URL +
      mConstants.ORDER_URL +
      "/customer/requests/" +
      requestId
  );

  let cities = await entityService.getCities();
  let districts = await entityService.getDistrict();
  let khoroos = await entityService.getKhoroos();

  customerRequest.city = cities.find(
    (x) => x.code.toString() === customerRequest.city
  )?.name;
  customerRequest.district = districts.find(
    (x) => x.code.toString() === customerRequest.district
  )?.name;
  customerRequest.khoroo = khoroos.find((x) => {
    return `${x.grand_parent}${x.parent}${x.code}` === customerRequest.khoroo;
  })?.name;

  return customerRequest;
}

export const customerRequestService = {
  getCustomerRequests,
  getCustomerRequest,
  updateCustomerRequest,
};
